export const makeBarOption = () => {
  return {
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      type: 'scroll',
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
    },
    yAxis: {
      type: 'value',
    },
    series: [],
  };
};

export const makeBarSeries = () => {
  return {
    type: 'bar',
    stack: 'stack',
  };
};
